import LTList from "../../LTGame/LTUtils/LTList";
import { LTUtils } from "../../LTGame/LTUtils/LTUtils";
import StringEx from "../../LTGame/LTUtils/StringEx";
import Vector3Ex from "../../LTGame/LTUtils/Vector3Ex";
import LTRes from "../../LTGame/Res/LTRes";
import GlobalUnit from "../common/GlobalUnit";
import ResDefine from "../common/ResDefine";
import { EnemyConfig } from "../config/EnemyConfig";
import { ItemConfig } from "../config/ItemConfig";
import { LevelConfig } from "../config/LevelConfig";
import ItemBlack from "./item/ItemBlack";
import ItemDoor_Change from "./item/ItemDoor_Change";
import ItemDoor_value from "./item/ItemDoor_value";
import ItemObstacle from "./item/ItemObstacle";
import ItemPet from "./item/ItemPet";
import ViewEenemy from "./ViewEnemy";
import ItemDoor_Level from "./item/ItemDoor_Level";
export var ELevelPoint;
(function (ELevelPoint) {
    ELevelPoint[ELevelPoint["Start"] = 0] = "Start";
    ELevelPoint[ELevelPoint["End"] = 1] = "End";
    ELevelPoint[ELevelPoint["Line"] = 2] = "Line";
})(ELevelPoint || (ELevelPoint = {}));
export default class ViewLevel {
    SetLevelId(id) {
        this.config = LevelConfig.data[id];
    }
    PreLoad(urls) {
        urls.push(ResDefine.FixScene(this.config.model_path));
        for (let i = 0; i < this.config.pids.length; i++) {
            let config = ItemConfig.data[this.config.pids[i]];
            urls.push(ResDefine.FixPath(config.model_path));
        }
        for (let id of this.config.enemy_pids) {
            urls.push(ResDefine.FixPath(EnemyConfig.data[id].model_path));
        }
    }
    CreateLevel(reload = false) {
        return __awaiter(this, void 0, void 0, function* () {
            let s3d;
            if (reload) {
                s3d = yield LTRes.LoadAndGet(ResDefine.FixScene(this.config.model_path));
            }
            else {
                s3d = LTRes.Get(ResDefine.FixScene(this.config.model_path));
            }
            GlobalUnit.ResetScene(s3d);
            this._levelObj = new Laya.Sprite3D("_levelObj_");
            s3d.addChild(this._levelObj);
            this._pathPoints = [];
            let path = s3d.getChildByName("_path_");
            for (let i = 0; i < path.numChildren; ++i) {
                this._pathPoints.push(path.getChildAt(i));
            }
            let light = s3d.getChildByName("Directional Light");
            LTUtils.EnableShadow(light, 32);
            GlobalUnit.game.camera.InitCamera(s3d.getChildByName("camera_obj"), light);
            GlobalUnit.game.player.Init(this._levelObj, this._pathPoints[ELevelPoint.Start].transform);
            this.CreateItem();
            this.CreateEenemy();
        });
    }
    GetLevelPoint(type) {
        return this._pathPoints[type];
    }
    CreateItem() {
        this._itemList = new LTList();
        let items = GlobalUnit.s3d.getChildByName("_items_");
        for (let i = 0; i < items.numChildren; i++) {
            let point = items.getChildAt(i);
            let types = StringEx.SplitToIntArray(point.name, "_");
            let id = types[0];
            let config = ItemConfig.data[id];
            let cls;
            switch (config.item_type) {
                case 1:
                case 2:
                    cls = new ItemDoor_value(point.transform, config, types);
                    break;
                case 3:
                    cls = new ItemObstacle(point.transform, config, types);
                    break;
                case 4:
                    cls = new ItemPet(point.transform, config, types);
                    break;
                case 5:
                    cls = new ItemDoor_Change(point.transform, config, types);
                    break;
                case 6:
                    cls = new ItemBlack(point.transform, config, types);
                    break;
                case 7:
                    cls = new ItemDoor_Level(point.transform, config, types);
                    break;
            }
            this._itemList.Add(cls);
        }
    }
    CreateEenemy() {
        this._enemyList = new LTList();
        let items = GlobalUnit.s3d.getChildByName("_enemy_");
        for (let i = 0; i < items.numChildren; i++) {
            let obj = items.getChildAt(i);
            let types = StringEx.SplitToIntArray(obj.name, "_");
            let config = EnemyConfig.data[types[0]];
            let enemy = new ViewEenemy(obj, config, types);
            this._enemyList.Add(enemy);
        }
    }
    GetEnemy(origin, num) {
        let dist = Number.MAX_VALUE;
        let target;
        for (let i = 0; i < this._enemyList.Count; i++) {
            let enemy = this._enemyList.Get(i);
            if (enemy.enemyType == 3)
                continue;
            if (!enemy.isEnabled)
                continue;
            let pos = enemy.rootObj.transform.position;
            if (pos.z < origin.z)
                continue;
            let long = Vector3Ex.Distance2D(origin, pos);
            if (Math.abs(long) < dist) {
                dist = long;
                target = enemy;
            }
        }
        return target;
    }
    ChangeDoorParams() {
        let len = this._itemList.Count;
        for (let i = 0; i < len; i++) {
            let item = this._itemList.Get(i);
            if (item.config.item_type == 1 || item.config.item_type == 2) {
                item.ChangeParamsToAdd();
            }
        }
    }
    RemoveItem(item) {
        this._itemList.Remove(item);
    }
    RemoveEnemy(item) {
        this._enemyList.Remove(item);
    }
    AddItemToLevel(item) {
        this._levelObj.addChild(item);
    }
    PlayFighted() {
        for (let i = 0; i < this._enemyList.Count; ++i) {
            this._enemyList.Get(i).ActiveFighted();
        }
    }
    Update(dt) {
        for (let i = 0; i < this._itemList.Count; ++i) {
            this._itemList.Get(i).Update(dt);
        }
        for (let i = 0; i < this._enemyList.Count; ++i) {
            this._enemyList.Get(i).Update(dt);
        }
    }
    LateUpdate(dt) {
        let count = 0;
        for (let i = 0; i < this._enemyList.Count; ++i) {
            let enemy = this._enemyList.Get(i);
            if (enemy.roadType == 2) {
                count++;
            }
        }
        if (count <= 0) {
            return true;
        }
        return false;
    }
    Clear() {
    }
}
